<template>
   <a-modal title="添加项目" :visible="visible" width="70%" :confirm-loading="confirmLoading" cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-row type="flex" justify="space-around">
                <a-col :span="12">
                    <a-form-model-item ref="projectId" label="挂牌项目" prop="projectId">
                        <a-select style="width: 380px" v-model="form.projectId" placeholder="请选择挂牌项目">
                            <a-select-option v-for="(ele,index) in quotationProjectList" :key="index" :value="ele.project_id">{{ ele.project_name }}</a-select-option>
                            </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item ref="quotationType" label="挂牌类型" prop="quotationType">
                        <a-select style="width: 380px" v-model="form.listedType" placeholder="请选择挂牌类型">
                            <a-select-option value="01">信用挂牌</a-select-option>
                            <a-select-option value="02">流转保证金挂牌</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="12">
                    <a-form-model-item ref="publicTime" label="公示时间" prop="publicTime">
                        <a-date-picker style="width: 380px" value-format="YYYY-MM-DD HH:mm:ss" show-time v-model="form.publicTime" placeholder="选择公示时间" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item ref="offTime" label="报名截止时间" prop="offTime">
                        <a-date-picker style="width: 380px" value-format="YYYY-MM-DD HH:mm:ss" show-time v-model="form.offTime" placeholder="选择报名截止时间" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="12">
                    <a-form-model-item ref="startTime" label="开始时间" prop="startTime">
                        <a-date-picker style="width: 380px" value-format="YYYY-MM-DD HH:mm:ss"  show-time v-model="form.startTime" placeholder="选择开始时间"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item ref="endTime" label="结束时间" prop="endTime">
                        <a-date-picker style="width: 380px"  value-format="YYYY-MM-DD HH:mm:ss"  show-time v-model="form.endTime" placeholder="选择结束时间" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="12">
                    <a-form-model-item ref="biddingPrice" label="起拍价" prop="biddingPrice">
                        <a-input  addon-after="万元" v-model="form.biddingPrice" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item ref="biddingUp" label="加价幅度" prop="biddingUp">
                        <a-input  addon-after="元"  v-model="form.biddingUp" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row type="flex" justify="space-around">
                <a-col :span="12">
                    <a-form-model-item ref="contact" label="联系人" prop="contact">
                        <a-input  v-model="form.contact" placeholder="请输入联系人姓名" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item ref="phone" label="联系电话" prop="phone">
                        <a-input  v-model="form.phone" placeholder="选择联系电话" />
                    </a-form-model-item>
                </a-col>
            </a-row>
       </a-form-model>
   </a-modal>    
</template>

<script>
export default {
     data(){
         return{
            visible:false,
            confirmLoading: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }, 
            form:{
                projectId:undefined,
                listedType:undefined,
                startTime:'', 
                endTime:'',
                publicTime:'',
                offTime:'',
                biddingPrice:'',
                biddingUp:'',
                contact:'',
                phone:''
            },
            endOpen: false,
            quotationProjectList:[],
            rules:{
                projectId:[
                    {
                        required: true,
                        message: "请选择挂牌项目",
                        trigger: "change",
                    }
                ],
                listedType:[
                    {
                        required: true,
                        message: "请选择挂牌类型",
                        trigger: "change",
                    }
                ],
                startTime:[
                    {validator:this.setStart,trigger:"change"},
                    {
                        required: true,
                        message: "请选择开始时间",
                        trigger: "change",
                    }
                ],
                endTime:[
                    {validator:this.setEnd,trigger:"change"},
                    {
                        required: true,
                        message: "请选择结束时间",
                        trigger: "change",
                    }
                ],
                publicTime:[
                    {validator:this.setPublic,trigger:"change"},
                    {
                        required: true,
                        message: "请选择公示时间",
                        trigger: "change",
                    },
                ],
                offTime:[
                    {validator:this.setOfftime,trigger:"change"},
                    {
                        required: true,
                        message: "请选择报名截止时间",
                        trigger: "change",
                    }
                ],
                biddingPrice:[
                    {
                        required: true,  
                        message: "请输入起拍价",
                        trigger: "blur",
                    }
                ],
                biddingUp:[
                    {
                        required: true,
                        message: "请输入加价幅度",
                        trigger: "blur",
                    },
                    {
                        pattern: /^\+?[1-9][0-9]*$/,
                        message: '请输入正整数',
                        trigger: "blur", 
                    }  
                ],
                contact:[
                    {
                        required: true,
                        message: "请输入联系人姓名",
                        trigger: "blur",
                    }
                ],
                phone:[
                    {
                        required: true,
                        message: "请输入联系人号码",
                        trigger: "blur",
                    },
                    {
                        pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                        message: '请输入正确的手机号',
                        trigger: "blur", 
                    }    
                ]
                
            }
         }
     },
     created(){
           this.$https.get('/portal/listing/quotationProject').then(res=>{
            if(res.code == 200){
                this.quotationProjectList = res.rows;
            }
        })
     },
     methods:{
        setStart(rule,value,callback){
            // 如果为空值，就抛出错误
            if(value == ''){
                callback(new Error("请选择开始时间!"));
            }else{
                callback();
            }    
        },
        setEnd(rule,value,callback){
            if(value == ''){
                callback(new Error("请选择结束时间!"));
            }else{
                callback();
            }   
        },
        setPublic(rule,value,callback){
          // 如果为空值，就抛出错误
            if(value == ''){
                callback(new Error("请选择公示时间!"));
            }else{
                callback();          
            }  
        },
        setOfftime(rule,value,callback){
            if(value == ''){
                callback(new Error("请选择报名截止时间!"));
            }else{
                callback();         
            }  
        },
        showDiolag(){
            this.visible = true;
        },
        handleOk(){
            //1时前面的日期在前
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if(this.$utils.bjDate(this.form.publicTime,this.form.offTime) == '2'){
                        this.$message.error('公示时间需要在报名时间之前')
                        return false;
                    }else if(this.$utils.bjDate(this.form.offTime,this.form.startTime) == '2'){
                        this.$message.error('报名时间需要在开始时间之前')
                        return false
                    }else if(this.$utils.bjDate(this.form.startTime,this.form.endTime) == '2'){
                        this.$message.error('开始时间需要在结束时间之前')
                        return false
                    }
                    this.confirmLoading = true;
                    this.$https.post('/portal/bidding/add',this.form).then(res=>{
                            this.confirmLoading = false;
                            if(res.code == 200){
                                this.$message.success('保存成功');
                                this.clear();
                                this.$emit('getDataList')
                                this.visible = false;
                            }else{
                                this.$message.error(res.msg);
                            }
                    }).catch(error=>{
                        this.confirmLoading = false;
                    })
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.visible = false;
        },
        clear(){
            this.form = {
               projectId:undefined,
               quotationType:undefined,
               quotationPrice:'',
               contactName:'',
               contactPhone:''
            }
        },
     }
}
</script>

<style>

</style>